export const CacheStrategy = {
  REQUEST_FIRST : 'REQUEST_FIRST',
  CACHE_FIRST   : 'CACHE_FIRST'  ,
  REQUEST_ONLY  : 'REQUEST_ONLY' ,
  CACHE_ONLY    : 'CACHE_ONLY'   ,
};
